import { render } from "./NewPresentation.vue?vue&type=template&id=d0484f1e&scoped=true"
import script from "./NewPresentation.vue?vue&type=script&lang=js"
export * from "./NewPresentation.vue?vue&type=script&lang=js"

import "./NewPresentation.vue?vue&type=style&index=0&id=d0484f1e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0484f1e"]])

export default __exports__